<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
body {
    margin: 0;
    height: 100vh;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    margin: 0 !important;
    height: 100%;
    /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue